import isHotkey from 'is-hotkey';

export default function() {
  return {
    onKeyDown(event, change) {
      if (isHotkey('shift+enter', event)) {
        return change.insertText('\n');
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/structured_text/plugins/NewLinePlugin/index.es6.js